import { createSelector } from "@reduxjs/toolkit";
import { selectSelfDashboard } from "./self.selector";

export const getDashboardState = createSelector(
    selectSelfDashboard,
    (state) => state
);
